// import logo from './logo.svg';
import '../../App.scss';
import React, { useState, useEffect } from "react";
import Banner from './main-banner/Banner.js';
import Navbar from './header/Navbar.js';
import Focus from './join/Join.js';
import Aqua from './press/Press.js';
import Scale from './whoweare/Whoweare.js';
import Raised from './raised/Raised.js';
import Market from './market/Market.js';
import Opinion from './opinion/Opinion.js';
import Join from './join/Join.js';
import Press from './press/Press.js';
import Whoweare from './whoweare/Whoweare.js';
import Strategy from './strategy/Strategy.js';
import Path from './Path/Path.js';





function Landing() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


  return (
    <>
      <Navbar />
      <Banner />
      <Path />
      <Opinion />
      <Raised />
      <Join />
      <Whoweare />
      <Strategy />
      {/* <Market /> */}
      {/* <Press /> */}



    </>
  );
}

export default Landing;